export {createProduct as '60362cbccedc348290b3135541659cf6233fad3ebf'} from 'ACTIONS_MODULE0'
export {updateProduct as '60dbe2a4e68876e93ec1a133bbb8678c7f7528d369'} from 'ACTIONS_MODULE0'
